import { Link } from "react-router-dom";
import { 
  Mail, 
  Phone, 
  MapPin, 
  Linkedin, 
  Twitter, 
  Github, 
  Building
} from "lucide-react";
import FooterLogo from "./FooterLogo";
import { openCookieSettings } from "@/lib/consent";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        {/* Company Header */}
        <div className="text-center mb-8 md:mb-12">
          <div className="flex items-center justify-center space-x-3 mb-2">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="cursor-pointer hover:opacity-80 transition-opacity"
              aria-label="Scroll to top"
            >
              <FooterLogo size="lg" />
            </button>
            <h3 className="text-xl md:text-2xl font-bold text-primary-foreground">
              Er lokala AI partner
            </h3>
          </div>
          <p className="text-accent text-sm font-medium">
            Mjukvaruutveckling, Webb & Rådgivning
          </p>
        </div>

        {/* Contact Info - Horizontal */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 mb-8 md:mb-12">
          <a 
            href="mailto:info@adgs.se"
            className="flex items-center space-x-2 text-primary-foreground/80 hover:text-accent transition-colors"
          >
            <Mail className="w-4 h-4 text-accent flex-shrink-0" />
            <span className="text-sm whitespace-nowrap">info@adgs.se</span>
          </a>
          <div className="flex items-center space-x-2 text-primary-foreground/80">
            <MapPin className="w-4 h-4 text-accent flex-shrink-0" />
            <span className="text-sm whitespace-nowrap">Malmö, Sverige</span>
          </div>
          <a 
            href="https://www.linkedin.com/company/spasovic-gonzalez" 
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 text-primary-foreground/80 hover:text-accent transition-colors"
          >
            <Linkedin className="w-4 h-4 text-accent flex-shrink-0" />
            <span className="text-sm whitespace-nowrap">LinkedIn</span>
          </a>
          <div className="flex items-center space-x-2 text-primary-foreground/80">
            <Building className="w-4 h-4 text-accent flex-shrink-0" />
            <span className="text-sm whitespace-nowrap">Org.nr: 559537-8083</span>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/20 pt-6 md:pt-8">
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6 text-sm">
            <p className="text-primary-foreground/60">
              © {new Date().getFullYear()} ADGS
            </p>
            <Link 
              to="/privacy" 
              className="text-primary-foreground/60 hover:text-accent transition-colors duration-300"
            >
              Integritetspolicy
            </Link>
            <Link 
              to="/terms" 
              className="text-primary-foreground/60 hover:text-accent transition-colors duration-300"
            >
              Användarvillkor
            </Link>
            <Link 
              to="/cookies" 
              className="text-primary-foreground/60 hover:text-accent transition-colors duration-300"
            >
              Cookies
            </Link>
            <button
              type="button"
              onClick={openCookieSettings}
              className="text-primary-foreground/60 hover:text-accent transition-colors duration-300"
            >
              Cookie-inställningar
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;